import Vue from 'vue'
import freshVueHistory from '@freshsolutions/fresh-vue-history'
import { apolloClient } from '@/plugins/vue-apollo'
import i18n from './i18n'

const eventTextFormatter = function (item) {
  const typenameText = i18n.t(`history.typenames.${item.historieable_type}`)
  const eventText = i18n.t(`history.events.${item.event}`)

  switch (item.event) {
    case 'CREATED':
    case 'UPDATED':
    case 'DELETED':
    case 'RESTORED':
      return typenameText + ' ' + eventText
    default:
      return eventText
  }
}

Vue.use(freshVueHistory, {
  i18n: i18n,
  apollo: apolloClient,
  eventTextFormatter: eventTextFormatter
})
